import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import IconScmpFlag from "./icon-scmp-flag.svg";

export const StyledIconScmpFlag = styled(IconScmpFlag)`
  inline-size: 13px;
  block-size: 10px;
`;

export const Label = styled.span`
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
`;

export const Container = styled.div`
  display: inline-flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  padding-block: 1px;
  padding-inline: 4px;

  border-radius: 2px;

  background-color: #333333;
`;
